import { lazy } from 'react';
import { RootAppComponentWithRoutes, RoutesData } from './routeWrapper';
import OrgAdminEnrollment from '../pages/orgAdminEnrollment';
import Register from '../pages/register';
import ResetPassword from '../pages/resetPassword';
import LoginPage from '../pages/login';
import NotRegisteredPage from '../pages/notRegistered';
import PostLogout from '../pages/PostLogout';
import IncorrectUser from '../pages/incorrectUser';
const Dashboard = lazy(() => import('../pages/dashboard'));
const DeviceManagement = lazy(() => import('../pages/deviceManagement'));
const Alerts = lazy(() => import('../pages/alerts'));
const alertsNeedingApproval = lazy(() => import('../pages/alerts/alertsNeedingApproval'));
const quickAlerts = lazy(() => import('../pages/alerts/quickAlerts'));
const DeviceSetUp = lazy(() => import('../pages/deviceSetUp'));
const ManageUpdates = lazy(() => import('../pages/manageUpdates'));
const DeviceLogs = lazy(() => import('../pages/deviceLogs'));
const Users = lazy(() => import('../pages/users'));
const UserGuide = lazy(() => import('../pages/userGuide'));
const ManageTemplates = lazy(() => import('../pages/manageTemplates'));
const Integration = lazy(() => import('../pages/integrations'));
const Das = lazy(() => import('../pages/integrations/das/Das'));
const Singlewire = lazy(() => import('../pages/integrations/singlewire/singlewire'));
const Everbridge = lazy(() => import('../pages/integrations/everbridge/everbridge'));
const Flashcast = lazy(() => import('../pages/integrations/flashcast/flashcast'));
const Cap = lazy(() => import('../pages/integrations/cap/Cap'));
const Alertus = lazy(() => import('../pages/integrations/alertus/Alertus'));
const Organizations = lazy(() => import('../pages/users/superAdmin/organizations'));
const OrgnaizationUsers = lazy(() => import('../pages/users/superAdmin/organizationUsers'));
const PublicApiDocs = lazy(() => import( '../pages/integrations/flashcast/PublicApiDocs'));
import Analytics from '../pages/analytics';
const SuperAdminDeviceManagement = lazy(
  () => import("../pages/users/superAdmin/deviceManagement/index")
);
// DEFAULTS (Not used as of now)
// const defaultRouteConfig = {
//    title: 'Page',
//    component: ({ location }:{location: any}) => {
//       return (
//          <h1>
//             You need to specify a component for <b>{location.pathname}</b>
//          </h1>
//       );
//    },
//    exact: true,
//    icon: 'question-circle',
//    showInMainNav: true
// };

// PUBLIC ROUTES
const publicRoutes: RoutesData[] = [
  {
    key: 'ROOT',
    path: '/',
    title: 'Home',
    component: LoginPage,
    exact: true,
    authRequired: false,
  },
  {
    key: 'ENROLLMENT',
    path: '/enrollment',
    title: 'ENROLLMENT',
    component: OrgAdminEnrollment,
    roles: ['ADMIN', 'OPERATOR'],
    authRequired: false,
    showInMainNav: 'skip',
  },
  {
    key: 'REGISTER',
    path: '/register',
    title: 'REGISTER',
    component: Register,
    roles: ['ADMIN', 'OPERATOR', 'SUPERADMIN', 'VIEWER'],
    authRequired: false,
    showInMainNav: 'skip',
  },
  {
    key: 'UNREGISTERED',
    path: '/not-registered',
    title: 'UNREGISTERED',
    component: NotRegisteredPage,
    roles: ['ADMIN', 'OPERATOR', 'SUPERADMIN', 'VIEWER'],
    authRequired: false,
    showInMainNav: 'skip',
  },
  {
    key: 'INCORRECT-USER-SELECTED',
    path: '/incorrect-user-selected',
    title: 'INCORRECT-USER',
    component: IncorrectUser,
    roles: ['ADMIN', 'OPERATOR', 'SUPERADMIN', 'VIEWER'],
    authRequired: false,
    showInMainNav: 'skip',
  },
  {
    key: 'RESET-USER-PASSWORD',
    path: '/reset-password',
    title: 'RESET-PASSWORD',
    component: ResetPassword,
    roles: ['ADMIN', 'OPERATOR', 'SUPERADMIN', 'VIEWER'],
    authRequired: false,
    showInMainNav: 'skip',
  },
  {
    key: 'POST-LOGOUT',
    path: '/post-logout',
    title: 'POST-LOGOUT',
    component: PostLogout,
    roles: ["ADMIN", "OPERATOR", "SUPERADMIN", "VIEWER"],
    authRequired: false,
    showInMainNav: "skip",
  },
  {
    key: "LOGIN",
    path: "/login",
    title: "Login",
    component: LoginPage,
    authRequired: false,
  },
];

// ORGANIZATION ROUTES
const organizationRoutes: RoutesData[] = [
  {
    key: 'APP',
    path: '/*',
    title: 'App',
    component: RootAppComponentWithRoutes,
    showInMainNav: 'skip',
    roles: ['ADMIN', 'OPERATOR', 'SUPERADMIN', 'VIEWER'],
    routes: [
      // OTHER ROLES ROUTES

      {
        key: 'DASHBOARD',
        path: '/dashboard',
        title: 'APP',
        component: Dashboard,
        roles: ['ADMIN', 'OPERATOR', 'VIEWER'],
        showInMainNav: true,
      },
      {
        key: 'DEVICE-MANAGEMENT',
        path: '/device-management',
        title: 'APP',
        component: DeviceManagement,
        showInMainNav: true,
        roles: ['ADMIN', 'OPERATOR', 'VIEWER'],
        authRequired: true,
      },
      {
        key: 'ALERTS',
        path: '/Alerts',
        title: 'ALERTS',
        component: Alerts,
        roles: ['ADMIN', 'OPERATOR', 'VIEWER'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'ALERTS-APPROVAL',
        path: '/alerts/alert-approval',
        title: 'ALERTS-APPROVAL',
        component: alertsNeedingApproval,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'QUICK-ALERTS',
        path: '/alerts/quick-alerts',
        title: 'QUICK-ALERTS',
        component: quickAlerts,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'DEVICE-SET-UP',
        path: '/device-set-up',
        title: 'DEVICE-SET-UP',
        component: DeviceSetUp,
        roles: ['ADMIN', 'OPERATOR'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'USER-GUIDE',
        path: '/user-guide',       
        title: 'User Guide',
        component: UserGuide,        
        roles: ['ADMIN', 'OPERATOR', 'VIEWER', 'SUPERADMIN'], 
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'MANAGE-UPDATES',
        path: '/manage-updates',
        title: 'MANAGE-UPDATES',
        component: ManageUpdates,
        roles: ['ADMIN', 'SUPERADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'MANAGE-TEMPLATES',
        path: '/manage-templates',
        title: 'MANAGE-TEMPLATES',
        component: ManageTemplates,
        roles: ['SUPERADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'DEVICE-LOGS',
        path: '/device-logs',
        title: 'DEVICE-LOGS',
        component: DeviceLogs,
        roles: ['SUPERADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'USERS',
        path: '/users',
        title: 'USERS',
        component: Users,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'DAS',
        path: '/integrations',
        title: 'DAS',
        component: Integration,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'dasConfigure',
        path: '/integrations/das',
        title: 'dasConfigure',
        component: Das,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'singlewireConfigure',
        path: '/integrations/singlewire',
        title: 'singlewireConfigure',
        component: Singlewire,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'everbridgeConfigure',
        path: '/integrations/everbridge',
        title: 'everbridgeConfigure',
        component: Everbridge,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'flashcastConfigure',
        path: '/integrations/flashcast',
        title: 'flashcastConfigure',
        component: Flashcast,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'alertusConfigure',
        path: '/integrations/alertus',
        title: 'alertusConfigure',
        component: Alertus,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'capConfigure',
        path: '/integrations/cap',
        title: 'capConfigure',
        component: Cap,
        roles: ['ADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      // SUPER-ADMIN ROUTES
      {
        key: 'ANALYTICS',
        path: '/analytics',
        title: 'ANALYTICS',
        component: Analytics,
        roles: ['SUPERADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'SUPER-ADMIN',
        path: '/super-admin',
    
        title: 'SUPER-ADMIN',
        component: Organizations,
        roles: ['SUPERADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'SUPER-ADMIN-USERS',
        path: '/super-admin/users',
        title: 'SUPER-ADMIN-USERS',
        component: OrgnaizationUsers,
        roles: ['SUPERADMIN'],
        authRequired: true,
        showInMainNav: true,
      },
      {
        key: 'PUBLIC-API-GUIDE',
        path: '/public-api-guide',
        title: 'PUBLIC-API-GUIDE',
        component: PublicApiDocs,
        roles: ['ADMIN', 'OPERATOR', 'SUPERADMIN', 'VIEWER'],
        authRequired: true,
        showInMainNav: 'skip',
      },
      {
        key: "SUPER-ADMIN-DEVICE-MANAGEMENT",
        path: "/super-admin/device-management",
        title: "SUPER-ADMIN-DEVICE-MANAGEMENT",
        component: SuperAdminDeviceManagement,
        roles: ["SUPERADMIN"],
        authRequired: true,
        showInMainNav: true,
      },
    ],
  },
];

export { publicRoutes, organizationRoutes };

export default publicRoutes;